























































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import HomeNavigationStore from '../Store/HomeNavigationStore'

@Component
export default class ComponentHomeTopNavBar extends Vue {
  get getHomeNavigationStore() {
    return getModule(HomeNavigationStore, this.$store)
  }

  get drawer() {
    return !!this.getHomeNavigationStore.navigationDrawer
  }

  set drawer(value: boolean) {
    this.getHomeNavigationStore.setNavigationDrawer(value)
  }

  logout() {
    this.$router.push('/logout')
  }

  windowWidth: number = 0

  get mobileBreakpoint() {
    return this.windowWidth < 768
  }

  get tabletBreakpoint() {
    return this.windowWidth < 960
  }

  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }
}
